import React from 'react';
import { useLocation } from 'react-router-dom';

import Router from 'Router';

import MainLayout from 'components/AppLayout/MainLayout';
import OnboardingLayout from 'features/onboarding/OnboardingLayout';

export default function AppLayout() {
  const { pathname } = useLocation();

  const getLayout = () => {
    switch (pathname) {
      case '/welcome':
      case '/show-around':
      case '/tour':
        return OnboardingLayout;

      case '/':
      default:
        return MainLayout;
    }
  };

  const Layout = getLayout();

  return (
    <Layout>
      <Router />
    </Layout>
  );
}
